import { useMutation } from '@apollo/client';

import { UpdateOrgaCommentInput } from '../../apollo/__generated__/graphql';
import { UPDATE_ORGA_COMMENT } from '../graphql/mutation/updateOrgaCommentMutation.graphql';

export const useUpdateOrgaCommentMutation = () => {
  const [mutate] = useMutation(UPDATE_ORGA_COMMENT);

  const updateOrgaComment = (
    updateOrgaCommentInput: UpdateOrgaCommentInput,
  ) => {
    mutate({
      variables: {
        updateOrgaCommentInput,
        eventId: updateOrgaCommentInput.eventId,
      },
    });
  };

  return { updateOrgaComment };
};
